import payments from '../../services/payments'

const initialState = () => ({
  paypalCreateRequestStatus: 0,
  paypalCreateRequestMessage: null
})

const state = initialState()

const getters = {
  paypalCreateRequestStatus: (state) => state.paypalCreateRequestStatus,
  paypalCreateRequestMessage: (state) => state.paypalCreateRequestMessage
}

const mutations = {
  paypalCreateRequest: state => void(state.paypalCreateRequestStatus = 1),
  paypalCreateRequestSuccess: state => {
    state.paypalCreateRequestStatus = 2
  },

  reset(state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}

const actions = {
  paypalCreateRequest: async ({ commit }, payload) => {
    try {
      commit("paypalCreateRequest");
      const response = await payments.paypal.createRequest(payload)
      console.log('Response: ', response)
      commit("paypalCreateRequestSuccess")
    }
    catch (e) {
      console.log('Error: ', e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
